import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f358379&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f358379",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f358379')) {
      api.createRecord('7f358379', component.options)
    } else {
      api.reload('7f358379', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f358379&scoped=true", function () {
      api.rerender('7f358379', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/couponTemplate/index.vue"
export default component.exports